import { IdSimNao } from '@/assets/ts/interfaces/general';

export interface LocalizacaoPontoUnidade {
  latitude: number;
  longitude: number;
}

export enum Tabs {
  MAIN,
  QR_CODE,
  R_FACIAL,
  ALMOCO,
  PHOTO,
  SAVE,
}

export interface VinculoPontoUnidade {
  BATIDAS_DIA_ATUAL?: string;
  BIOMETRIA_CADASTRADA: 'Sim' | 'Não';
  DSMOTIVOESTAB?: string;
  DTADMISSAOVINC: string;
  DTBASESINDICAL?: string;
  DTBASESINDICAL_ATUAL?: string;
  DTBASESINDICAL_ATUAL_MIN?: string;
  DTFIMESTABVINC?: string;
  DTRESCISAOVINC?: string;
  HASHFACIAIS?: string[];
  HASHFACIAL?: string;
  HORARIOS_MARCACOES_DIA_ATUAL?: string;
  IDAFASTSITUFUNC: IdSimNao;
  IDCOTAPCDAPRENDIZ: IdSimNao;
  IDDESLGOURESCD: IdSimNao;
  IDSITUACAOESTAB: IdSimNao;
  ISVINCULOFERIAS: IdSimNao;
  NMPESSOA: string;
  NMVINCULOM: string;
  NMVINCULOM_NMESCALATRABH: string;
  NRCPFPESSOA: string;
  NRESTRUTGEREN: string;
  NRESTRUTLEGAL: string;
  NRNMVINCULO: string;
  NRORG: string;
  NRPARCNEGOCIO: string;
  NRPESSOA: string;
  NRTIPOVINCULOM: string;
  NRVINCULOEMPREG: string;
  NRVINCULOM: number;
}

export interface LocalizacaoPontoUnidade {
  latitude: number;
  longitude: number;
}

export interface MarcacaoPontoUnidade {
  localizacao: LocalizacaoPontoUnidade;
  vinculo: VinculoPontoUnidade;
  picture: string;
}

export type CacheMarcacoes = Map<number, string[]>;

export interface ResponseEnviaMarcacao {
  success: boolean;
  marcacoesDia: string[];
  nrmarcacaoponto: number;
  file: {
    base64: string;
    name: string;
    ttpe: string;
  };
}
